import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
// import { sentence } from 'to-case';
import Toggle from 'library/components/form-elements/toggle';
import Cache from 'library/util/cache';
import HiringConfig from 'apps/admin/components/config/hiring';
import PathwaysConfig from 'apps/admin/components/config/pathways';
import EditCoursesModal from 'apps/admin/components/config/edit-courses-modal';
import SortableContainer from 'apps/admin/components/config/sortable-container.js';

const ModuleManagement = ({ allModules, enabledModules, onChange, disabled=false, updateSortPosition, userConfig, orgConfig, defaultConfig }) => (
  <SortableContainer updateSortPosition={updateSortPosition}>
    {
      (allModules||[]).map((m)=>(
        <Fragment key={m}>
          <Toggle name={m} onChange={onChange} checked={enabledModules.includes(m)} disabled={disabled} />
          <span className="pairin-admin-segments-module-name">{ m }</span>
        </Fragment>
      ))
    }
  </SortableContainer>
);

const DefaultConfig = () => (
  <h4>No Config Data</h4>
);


const ManageCourses = (props) => (
  <button style={{justifyContent: 'center'}} {...props}>
    Edit Visable Courses
  </button>
);


const PERSONAL_MODULES = ['my-development','curriculum','targets'];
class PersonalConfig extends React.Component {
  state = {
    modules: [],
    allModules: PERSONAL_MODULES
  }

  static getDerivedStateFromProps ({ config }, prevState) {
    const modules = resolve(config, 'availableModules', []);

    if (!modules.every(v=>prevState.modules.indexOf(v)>-1) || !prevState.modules.every(v=>modules.indexOf(v)>-1)) {
      return {
        modules: modules,
        allModules: PERSONAL_MODULES.sort((a,b)=>modules.indexOf(a)-modules.indexOf(b))
      };
    }

    return null;
  }

  handleModuleChange = ({ target: { name, value }}) => {
    const availableModules = new Set(this.state.modules);
    if (value) {
      availableModules.add(name);
    } else {
      availableModules.delete(name);
    }

    this.setState({
      modules: Array.from(availableModules)
    });
    this.props.onUpdate({
      availableModules: Array.from(availableModules)
    });
  }

  handleChange = async (e) => {
    const {
      name, value
    } = e.target;

    const allowedPrefixes = ['preview'];
    const [pre, title] = name.split('-');

    if (allowedPrefixes.includes(pre) && title) {
      const existing = {...resolve(this.props, `config/${pre}`, {})};

      existing[`${title}`] = value;
      await this.props.onUpdate({preview_courses: existing});
    } else {
      await this.props.onUpdate({[name]: value });
    }
  }

  updateSortPosition = (from, to) => {
    let modules = [...this.state.allModules];
    const tmp = modules[from];
    modules.splice(from, 1);
    modules.splice(to, 0, tmp);

    this.setState({
      allModules: [...modules]
    });

    modules = modules.filter(m=>this.state.modules.indexOf(m)>-1);

    this.setState({
      modules: modules
    });

    this.props.onUpdate({
      availableModules: modules
    });
  };

  render() {
    const {
      config,
      onUpdate,
      disabled,
      userConfig,
      orgConfig,
      defaultConfig
    } = this.props;

    const {
      allModules,
      modules
    } = this.state;

    return (
      <div className="pairin-admin-segments-modules">
        <ModuleManagement
          allModules={allModules}
          enabledModules={modules}
          onChange={this.handleModuleChange}
          disabled={disabled}
          userModules={resolve(userConfig, 'availableModules', [])}
          orgModules={resolve(orgConfig, 'availableModules', [])}
          defaultModules={resolve(defaultConfig, 'availableModules', [])}
          updateSortPosition={this.updateSortPosition}
        />
        <hr />
        <label>
          <Toggle
            checked={resolve(config, 'has_ti', false)}
            name={'has_ti'}
            onChange={this.handleChange}
            disabled={disabled}
          />
          <span>Use TI Curriculum</span>
        </label>
        <label>
          <Toggle
            checked={resolve(config, 'ti_highschool', false)}
            name={'ti_highschool'}
            onChange={this.handleChange}
            disabled={disabled}
          />
          <span>High School Curriculum</span>
        </label>
        <label>
          <Toggle
            checked={resolve(config, 'preview_curriculum', false)}
            name={'preview_curriculum'}
            onChange={this.handleChange}
            disabled={disabled}
          />
          <span>Preview Curriculum</span>
        </label>
        {
          resolve(config, 'preview_curriculum', false)
            ? <EditCoursesModal
              onChange={this.handleChange}
              component={ManageCourses}
              config={config}
            />
            : null
        }
      </div>
    );
  }
}
//
// const PersonalConfig = ({ config, onUpdate, disabled }) => {
//   const availableModules = resolve(config, 'availableModules', []);
//   const allModules = ['my-development','curriculum','targets'].sort((a,b)=>availableModules.indexOf(a)-availableModules.indexOf(b));
//
//   const handleChange = ({ target: { name, value } }) => {
//     const availableModules = new Set(resolve(config, 'availableModules', []));
//     if (value) {
//       availableModules.add(name);
//     } else {
//       availableModules.delete(name);
//     }
//
//     onUpdate({
//       availableModules: Array.from(availableModules)
//     });
//   };
//
//   const updateSortPosition = (from, to) => {
//     let modules = [...allModules];
//     const tmp = modules[from];
//     modules.splice(from, 1);
//     modules.splice(to, 0, tmp);
//
//     modules = modules.filter(m=>availableModules.indexOf(m)>-1);
//
//     onUpdate({
//       availableModules: modules
//     });
//   };
//
//   return ();
// };

export default {
  personal: PersonalConfig,
  pathways: PathwaysConfig,
  hiring: HiringConfig,
  default: DefaultConfig
};
